"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var DefaultButton_1 = require("../../../common/components/presentation/Buttons/DefaultButton");
var GoHomeButtonStyles_1 = require("./GoHomeButtonStyles");
var GoHomeButton = function (_a) {
    var homePageURL = _a.homePageURL;
    var style = GoHomeButtonStyles_1.default();
    var redirectToHomePage = react_1.useCallback(function () {
        window.location.href = homePageURL;
    }, []);
    return (<core_1.Box className={style.buttonWrapper}>
      <DefaultButton_1.default className={[style.button]} dataTest="button:checkout:redirectHome" variant="contained" onClick={redirectToHomePage}>
        <Translation_1.default id="confirmation.button.goHome" defaultMessage="Go Home"/>
      </DefaultButton_1.default>
    </core_1.Box>);
};
exports.default = GoHomeButton;
